<template>
  <Row>
    <Row>
      <i-col span="12"> <label class="ivu-form-item-label">Date</label> </i-col>
      <i-col span="12">
        <label class="ivu-form-item-label">Figure</label>
      </i-col>
    </Row>
    <Row
      v-for="(item, index) in strataData"
      :key="index"
      style="margin-bottom:6px;"
    >
      <i-col span="10">
        <StringDatePicker
          v-model="item.date"
          style="width:100%;padding-right:6px;"
        ></StringDatePicker>
      </i-col>
      <i-col span="10">
        <i-input
          v-model.number="item.figure"
          style="padding-right:6px;"
        ></i-input>
      </i-col>
      <i-col span="4">
        <i-button @click="remove(index)" style="width:100%;">
          <FFIcon type="remove" /> Remove
        </i-button>
      </i-col>
    </Row>
    <Row>
      <i-col span="24">
        <i-button @click="add"><FFIcon type="plus" /> Add</i-button>
      </i-col>
    </Row>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
  </Row>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      strataData: this.value || [],
    };
  },
  watch: {
    value() {
      this.strataData = this.value || [];
      // this.fixDates();
    },
  },
  created() {
    window.EventBus.$on("VALIDATE_DATA", this.validate);
  },
  methods: {
    // Adds an addition row at the bottom of the list
    add() {
      this.strataData.push({ date: "", figure: "" });
      // this.fixDates();
      this.$emit("input", this.strataData);
    },

    fixDates() {
      for (const item of this.strataData) {
        if (item.date !== "") {
          let date = moment(item.date);
          item.date = date.format("YYYY-MM-DD");
        }
      }
    },
    // fixDate(item) {
    //   if (item.date !== "") {
    //     console.log(item.date);
    //     let date = moment(item.date);
    //     item.date = date.format("YYYY-MM-DD");
    //   } else {
    //     item.date = "";
    //   }
    // },
    // Removes a specific row from the list
    remove(index) {
      this.strataData = _.filter(this.strataData, (item, i) => i !== index);
      // this.fixDates();
      this.$emit("input", this.strataData);
    },

    // Make sure there are no empty rows
    validate() {
      this.strataData = _.filter(
        this.strataData,
        item => item.date !== "" && item.figure !== ""
      );
    },
  },
};
</script>

<style lang="css"></style>
